import { useContext, useCallback } from "react";
import PolyglotContext from "./context";

export function usePolyglot() {
  return useContext(PolyglotContext);
}

export function useTranslation() {
  var polyglot = usePolyglot();
  return useCallback(polyglot.t.bind(polyglot), [polyglot]);
}